import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import moment from 'moment'
import template from './match-times.jade'
import {Match} from '../../models'
import notify from '@scoutgg/ftw/source/services/notification'
import '@scoutgg/ftw/source/atoms/button/button'
import '../status'
import getStateOld from '../../services/create-event'
import getState from '../../services/event-state'
import {prompt} from '@scoutgg/ftw/source/services/modal'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('disable-pause', Boolean)
export default class MatchTimes extends HTMLElement {
  created() {
    setInterval(() => this.render(), 10 * 1000)
  }

  attached() {
    this.reload()
    this.matchChange()
  }

  prompt(status, endpoint, question) {
    return prompt(question, { type: 'yesno' }).then(() => {
      this.updateStatus(status, endpoint)
    })
  }

  updateStatus(status, endpoint, params = {}) {
    const prev = this.match.status
    this.match.status = status
    this.render()
    return this.match.post(endpoint, params)
      .then(() => {
        this.emit('changed-status:match')
        this.reload()
      })
      .catch(err => {
        notify(err.message || err.error, {level: 'danger', timeout: 10000})
        this.match.status = prev
        this.render()
      })
  }

  matchChange() {
    getState(this.match).listen(this, true)
    getStateOld(this.match).listen(this, true)
    this.reload()
  }

  getMatchTime(match, round) {
    var time = match.roundTimes && match.roundTimes[round]
    if(!time) return
    return moment(time).format('HH:mm')
  }

  get startable() {
    return +moment(this.match.startTime) - Date.now() < 60 * 1000
  }

  reload() {
    getState(this.match).reload()
    getStateOld(this.match).reload(true)
  }

  async cancel() {
    const str = await prompt('Type "CANCEL" to cancel this match', {
      min: 1,
      max: 10,
    })
    return this.updateStatus('cancelled', 'cancel', { code: str })
  }
}
